<template>
  <div class="d-flex align-items-center">
    <div class="title shine col-7 pr-2"></div>
    <div class="col-5 d-flex justify-content-between circles">
      <div class="circle  mr-3 rounded-circle shine"></div>
      <div class="circle  mr-3 rounded-circle shine"></div>
      <div class="circle  mr-3 rounded-circle shine"></div>
      <div class="circle  mr-3 rounded-circle shine"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Initiative'
}
</script>

<style lang="scss" scoped>
.circle {
  height: 30px;
  width: 30px;
  flex-shrink: 0;
}
.title {
  height: 30px;
  border-radius: 10px;
}
.circles {
  padding: 0 20px 0 90px;
}
</style>
